module.exports = __webpack_public_path__ + "static/audit-0937d9aa373f1e6f86be857fa4841084.jpg";